import {
    DATES_ADAPTER_TYPE,
    type DatesAdapter,
    JSON_ADAPTER_TYPE,
    type JsonAdapter
} from "inversify-utils-kit";
import { createPinia } from "pinia";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";
import { registerSW } from "virtual:pwa-register";
import { createApp } from "vue";
import { createI18n } from "vue-i18n";
import { createMetaManager, plugin as metaPlugin } from "vue-meta";

import en from "@/i18n/locales/en.json";
import es from "@/i18n/locales/es.json";

import { version } from "../package.json";
import App from "./App.vue";
import "./assets/main.css";
import { HOST, SITE_TITLE } from "./common/constants";
import { AppContainer } from "./config";
import router from "./router";

const app = createApp(App);
app.config.globalProperties.$publicUrl = HOST;
app.config.globalProperties.$siteTitle = SITE_TITLE;
app.config.globalProperties.$version = version;

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);
app.use(pinia);
app.use(router);
app.use(createMetaManager());
app.use(metaPlugin);
app.use(
    createI18n({
        locale: "es",
        fallbackLocale: "en",
        messages: { en, es },
        globalInjection: true
    })
);
const datesAdapter = AppContainer.get<DatesAdapter>(DATES_ADAPTER_TYPE);
app.provide("datesAdapter", datesAdapter);
const jsonAdapter = AppContainer.get<JsonAdapter>(JSON_ADAPTER_TYPE);
app.provide("jsonAdapter", jsonAdapter);

app.mount("#app");

const updateSW = registerSW({
    onNeedRefresh() {
        if (confirm("Hay una nueva versión disponible. ¿Deseas actualizar?")) {
            updateSW(true);
        }
    },
    onOfflineReady() {
        console.log("Aplicación lista para usarse sin conexión");
    }
});
